var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNft = function SvgNft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 256 256",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -1.05 0 -2.099 -0.27 -3.035 -0.81 L 8.248 69.723 c -1.872 -1.08 -3.035 -3.095 -3.035 -5.257 V 25.534 c 0 -2.162 1.163 -4.177 3.035 -5.257 L 41.965 0.811 c 1.873 -1.081 4.198 -1.081 6.071 0 l 33.716 19.466 c 1.872 1.08 3.035 3.095 3.035 5.257 v 38.932 c 0 2.162 -1.163 4.177 -3.036 5.257 L 48.035 89.19 C 47.099 89.73 46.049 90 45 90 z M 45 3.999 c -0.358 0 -0.716 0.092 -1.035 0.276 L 10.248 23.741 c -0.638 0.369 -1.035 1.056 -1.035 1.793 v 38.932 c 0 0.737 0.397 1.424 1.034 1.792 l 33.717 19.467 c 0.639 0.369 1.432 0.369 2.071 0 l 33.715 -19.467 c 0.639 -0.368 1.035 -1.055 1.035 -1.792 V 25.534 c 0 -0.737 -0.397 -1.424 -1.035 -1.793 L 46.035 4.275 C 45.716 4.091 45.358 3.999 45 3.999 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.863 57.711 c -0.679 0 -1.328 -0.347 -1.699 -0.945 l -9.597 -15.461 v 14.407 c 0 1.105 -0.896 2 -2 2 s -2 -0.896 -2 -2 V 34.289 c 0 -0.894 0.592 -1.678 1.452 -1.923 c 0.858 -0.245 1.776 0.109 2.248 0.869 l 9.597 15.461 V 34.289 c 0 -1.105 0.896 -2 2 -2 s 2 0.896 2 2 v 21.422 c 0 0.894 -0.592 1.679 -1.452 1.924 C 34.23 57.686 34.045 57.711 33.863 57.711 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 42.17 57.711 c -1.105 0 -2 -0.896 -2 -2 V 34.289 c 0 -1.105 0.896 -2 2 -2 h 8.519 c 1.105 0 2 0.896 2 2 s -0.896 2 -2 2 H 44.17 v 19.422 C 44.17 56.815 43.274 57.711 42.17 57.711 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.689 47 H 42.17 c -1.105 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 8.519 c 1.105 0 2 0.896 2 2 S 51.793 47 50.689 47 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.433 36.289 H 57.259 c -1.105 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 12.175 c 1.105 0 2 0.896 2 2 S 70.538 36.289 69.433 36.289 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 63.346 57.711 c -1.105 0 -2 -0.896 -2 -2 V 34.289 c 0 -1.105 0.896 -2 2 -2 s 2 0.896 2 2 v 21.422 C 65.346 56.815 64.45 57.711 63.346 57.711 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nft.a18a0827ae6b491047bb67e3b4fc676f.svg";